import { useState } from "react";
import { ActionIcon, Card, Group, Tooltip } from "@mantine/core";
import { useHover } from "@mantine/hooks";
import { IconPlayerPlayFilled, IconPlaylistAdd } from "@tabler/icons-react";
import ExtendVideoModal from "./ExtendVideoModal";
import ResultFeedback from "../_Common/ResultFeedback";

export function GalleryVideoCard({ image, onClick, selectionMode }) {
  const { ref, hovered } = useHover();
  const [extendOpen, setExtendOpen] = useState(false);

  return (
    <>
      <Card
        withBorder
        shadow="sm"
        radius="md"
        pb={0}
        onClick={() => {
          selectionMode ? false : onClick();
        }}
        style={{ cursor: "pointer" }}
        ref={ref}
      >
        <Card.Section style={{ position: "relative" }}>
          <video
            width="100%"
            height="auto"
            preload="metadata"
            muted
            playsInline
            poster={image.videoPosterUrl || undefined}
            style={{ display: "block" }}
          >
            <source src={image.videoUrl} type="video/mp4" />
          </video>
          <div
            style={{
              position: "absolute",
              inset: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              pointerEvents: "none",
            }}
          >
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                background: "rgba(0, 0, 0, 0.55)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
              }}
            >
              <IconPlayerPlayFilled size={28} />
            </div>
          </div>
          {hovered && !selectionMode && (
            <Group
              gap={4}
              style={{ position: "absolute", top: 8, left: 8 }}
              bg="rgba(0, 0, 0, 0.55)"
              p={4}
              radius="md"
            >
              <ResultFeedback
                logicalImageId={image.logicalImageId}
                dark
                size="sm"
              />
            </Group>
          )}
          {(hovered || extendOpen) && !selectionMode && (
            <Tooltip label="Extend clip" withArrow position="left">
              <ActionIcon
                variant="filled"
                color="dark"
                size="lg"
                style={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  opacity: 0.85,
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setExtendOpen(true);
                }}
                aria-label="Extend clip"
              >
                <IconPlaylistAdd size={18} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          )}
        </Card.Section>
      </Card>
      <ExtendVideoModal
        opened={extendOpen}
        onClose={() => setExtendOpen(false)}
        source={image}
      />
    </>
  );
}
